// qa.ts — in-browser QA gate over a pulled session (EGO-99 step 5).
//
// Thin seam over core/'s parity-tested QA port: core provides
// assessSource(SessionSource) plus a browser SessionSource over a
// FileSystemDirectoryHandle. Same gates, thresholds, and certificate schema
// as the tools/qa python oracle.
import { assessSource } from "../../core/src/qaSession.ts";
import { webSource } from "../../core/src/webSource.ts";
import type { QaCertificate } from "../../core/src/types.ts";

export async function runQa(dir: FileSystemDirectoryHandle): Promise<QaCertificate> {
  return await assessSource(webSource(dir));
}
